import { ApiService } from "./ApiService"

export class EmployeeService {

    static uri = '/employee';

    static get({search, sort, perPage, page,}) {
        return ApiService.get(`${this.uri}?search=${search}&sort=${sort}&per_page=${perPage}&page=${page}`);
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data);
    }
}